import { configureStore } from "@reduxjs/toolkit";
import alertMessage from "../slice/alertMessage";
import { rtkQueryErrorLogger } from "../slice/errorLogger";

//

const store = configureStore({
  reducer: {
    alertMessage: alertMessage,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkQueryErrorLogger),
});

export default store;
